/* eslint-disable no-unused-vars */

import Vue from 'vue'

export const NotificationScheduleListModule = {
	strict: true, // for developement only
	namespaced: true,
	state: {
		grid: [
			{
				title: 'NotificationSchedule',
				name: 'notificationSchedules',
				statusLookup: 'getIsActive',
				showFilter: true,
				columns: [
					{
						key: "notificationTypeId",
						label: 'TYPE',
						sortable: true,
						widths: "xs24 l6",
			},
					{
						key: 'isActive',
						label: "STATUS",
						filter: {
							show: false
						},
						sortable: false,
						widths: "xs24 l2",
						separator: true
			},
					{
						key: 'appText',
						label: "App Message",
						widths: "xs24 l6",
						separator: true
			},
					{
						key: 'fromMinute',
						label: "Send",
						widths: "xs24 l5",
						separator: true
			},
					{
						key: 'lcrUser',
						label: "User Type",
						widths: "xs24 l5",
						separator: true
					},
			]
		},
		],
		data: Array(),
		params: {
			sortOrder: null,
			sortBy: null,
			keywords: null
		}
	},
	mutations: {
		setData: (state, payload = Array()) => state.data = payload,
		setParams: (state, params) => {
			state.params = {
				...state.params,
				...params
			}
		},
		resetParams: state => {
			state.params = {}
		},
		setPagination: (state, attr) => {
			state.data = {
				...state.data,
				...attr
			}
		},
		removeElement: (state, attribute) => {
			let paramState = {...state.params
			}
			delete paramState[attribute]
			state.params = {...paramState
			}
		}
	},
	getters: {
		getAllData: state => state.data,
		getRecords: state => state.data.data,
		getGrid: state => state.grid,
		getTotals: state => state.data.total,
		getPagination: state => {
			return {
				count: state.data.count,
				page: state.data.page,
				perPage: state.data.perPage
			}
		},
		getParams: state => {
			return state.params
		}
	},
	actions: {
		async load({
			commit,
			rootState
		}, params = Object()) {
			if (params) {
				if (params.fromDateTime) {
					if (params.fromDateTime == "Invalid date") {
						params.fromDateTime = null;
					}
				}
				if (params.toDateTime) {
					if (params.toDateTime == "Invalid date") {
						params.toDateTime = null;
					}
				}
			}
			let res = await Vue.prototype.$http.post(rootState.apiUrl + '/notification-schedule/list/', params)
			commit('setData', res.data)
		},
		async loadAssignable({
			commit,
			rootState
		}, params = Object()) {
			if (params) {
				if (params.fromDateTime) {
					if (params.fromDateTime == "Invalid date") {
						params.fromDateTime = null;
					}
				}
				if (params.toDateTime) {
					if (params.toDateTime == "Invalid date") {
						params.toDateTime = null;
					}
				}
			}
			let res = await Vue.prototype.$http.post(rootState.apiUrl + '/notification-schedule/assignable/', params)
			commit('setData', res.data)
		},
		async loadEditable({
			commit,
			rootState
		}, params = Object()) {
			if (params) {
				if (params.fromDateTime) {
					if (params.fromDateTime == "Invalid date") {
						params.fromDateTime = null;
					}
				}
				if (params.toDateTime) {
					if (params.toDateTime == "Invalid date") {
						params.toDateTime = null;
					}
				}
			}
			let res = await Vue.prototype.$http.post(rootState.apiUrl + '/notification-schedule/editable/', params)
			commit('setData', res.data)
		},
		async loadViewable({
			commit,
			rootState
		}, params = Object()) {
			if (params) {
				if (params.fromDateTime) {
					if (params.fromDateTime == "Invalid date") {
						params.fromDateTime = null;
					}
				}
				if (params.toDateTime) {
					if (params.toDateTime == "Invalid date") {
						params.toDateTime = null;
					}
				}
			}
			let res = await Vue.prototype.$http.post(rootState.apiUrl + '/notification-schedule/list/', params)
			commit('setData', res.data)
		},
		async loadWorkFor({
			commit,
			rootState
		}, params = Object()) {
			let res = await Vue.prototype.$http.post(rootState.apiUrl + '/notification-schedule/list-work-for/', params)
			commit('setData', res.data)
		},
		clearParams({
			commit
		}) {
			commit('resetParams')
		},
		updateParams({
			commit
		}, params = Object()) {
			commit('setParams', params)
		},
		clearStatusFilters({
			commit
		}) {
			let params = {
				approvalStatusId: null,
				activeStatusId: null
			}
			commit('setParams', params)
		},
		removePropInParam({
			commit
		}, attr = '') {
			commit('removeElement', attr)
		},
		updatePagination({
			commit
		}, attr) {
			commit('setPagination', attr)
		}
	}
}